
document.addEventListener('DOMContentLoaded', function() {
  // Select all elements with data-add-btn
  const triggerButtons = document.querySelectorAll('[data-add-btn]');
  const mainCTA = document.querySelector('.product-form__buttons button');

  if (!triggerButtons.length || !mainCTA) return;

  triggerButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();

      // Smooth scroll to main CTA
      // mainCTA.scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'center'
      // });

      // After scroll completes, trigger click (with slight delay for scroll)
      setTimeout(() => {
        mainCTA.click();
      }, 700); // adjust delay if needed
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.review-swiper-block', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.review-swiper-next',
      prevEl: '.review-swiper-prev'
    }
  });
});



